export default __webpack_public_path__ + "static/media/bg-promo.9eae0d99.svg";